/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react'
import { useAppSelector } from '../../../../reducers';
import NumberFormat from '../../../../utils/number-format';
import { getHistoricalReportData, processInsightsData, DataProcessor } from '../utils/selectors';
import { GenericDataProps } from '../utils/constants';
import { getUnitForUtrCodes, getUnitWithNumberScale } from '../utils/unitText';
import { DataOrNotWrapper } from './DataOrNotWrapper';

export const GenericData = React.memo((props: GenericDataProps) => {
  const {
    width = 280,
    height = 120,
    variables,
    decimalPlaces,
    suffix,
    dataProcessor = DataProcessor.Number,
  } = props;

  const historicalReportData = useAppSelector(getHistoricalReportData);
  const value = processInsightsData(dataProcessor, historicalReportData, variables);

  const unitInfo = getUnitForUtrCodes(historicalReportData, variables);
  const unitText = props.unitText !== undefined ? props.unitText : getUnitWithNumberScale(unitInfo);

  return (
    <DataOrNotWrapper
      width={width}
      height={height}
      showNoData={value === undefined}
      utrCodes={Array.from((new Set(variables ? Object.values(variables).map(v => v.code) : [])).values())}
    >
      <div className='h-100 d-flex flex-column justify-content-center'>
        <div className='mt-2 key-number'>
          <NumberFormat value={value} suffix={suffix} decimalPlaces={decimalPlaces} />
        </div>
        <div className='text-center key-number-unit'>{unitText}</div>
      </div>
    </DataOrNotWrapper>
  );
});

GenericData.displayName = 'GenericData';
